export const SET_CREATE_OR_EDIT_MATCH_TYPE = 'SET_CREATE_OR_EDIT_MATCH_TYPE';

export function setCreateOrEditMatchType(matchType) {
  return {
    type: SET_CREATE_OR_EDIT_MATCH_TYPE,
    matchType,
  };
}
